import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';

import { SiteNav } from '../SiteNav/SiteNav.tsx';
import { useHeaderFooterServerVars } from '../HeaderFooterServerVarsContext/HeaderFooterServerVarsContext.tsx';

import dibsCss from 'dibs-css';
import classnames from 'classnames';
import styles from './BottomBar-style.scss';

import { type BottomBar_viewer$key } from './__generated__/BottomBar_viewer.graphql.ts';

type BottomBarProps = {
    viewer: BottomBar_viewer$key;
};

export const BottomBar: FC<BottomBarProps> = ({ viewer: viewerRef }) => {
    const viewer = useFragment(
        graphql`
            fragment BottomBar_viewer on Viewer {
                ...SiteNav_viewer
            }
        `,
        viewerRef
    );
    const { isHeaderFullWidth } = useHeaderFooterServerVars();

    return (
        <div className={styles.bar}>
            <div
                className={classnames(styles.barContent, {
                    [styles.isFullWidth]: isHeaderFullWidth,
                })}
            >
                <div
                    className={classnames(dibsCss.flex, dibsCss.justifyEnd, dibsCss.hFull)}
                    data-tn="main-nav-bottom"
                >
                    <SiteNav viewer={viewer} />
                </div>
            </div>
        </div>
    );
};
